export default __webpack_public_path__ + "static/1_MasterCard-93246c4e69dcf2460a5d9445596bd555.png";